export enum BoardElementEnum {
  IMAGE = 'IMAGE',
  GIF = 'GIF',
  VIDEO = 'VIDEO',
  DRAWING = 'DRAWING',
  NOTE = 'NOTE',
  GAME = 'GAME',
  OTHER = 'OTHER',
}
